<template>
  <div class="row">
    <div class="is-fullhd">
      <div class="columns" style="margin: 10px 10px">
        <span class="column is-2">
        </span>
        <span class="column is-8" >
          <div class="panel panel-default">
            <div class="panel-body">
              <p class="text-center"
                style="font-family: 'Open Sans', Roboto, sans-serif; font-size: 16px; color: blue;">
                These are comments made by the users of the dashboard from different locations world over.
                Comments are saved on the user browser, and syncs with the to the cloud when there's internet
                Note that only superadmin users can delete unuseful comments.
              </p>
            </div>
          </div>
        </span>
      </div>
      <div class="columns">
        <div class="column is-2"></div>
        <div class="column is-8">
          <!-- max-height="500px" -->
          <vue-good-table
            class="table table-responsive"
            :columns="columns"
            :rows="rows"
            :lineNumbers="true"
            :fixed-header="false"
            :search-options="{
              enabled: false,
            }"
            :paginationOptions="{
              enabled: true,
              mode: 'pages',
              perPageDropdown: [5, 8, 10, 15, 25]
            }"
            :rowStyleClass="rowStyleClassFn"
            styleClass="vgt-table table table-bordered table-striped comments_table">
            <div slot="emptystate">
              <span class="text-center">
                <img src="static/img/no_data.png">
              </span>
            </div>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'action'">
                <v-btn :ripple="false" @click="loadComment(props.row, $event)"><v-icon color="blue">visibility</v-icon></v-btn>
              </span>
              <span v-else style="font-family: Roboto; font-size: 18px">
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
            <template slot="table-column" slot-scope="props">
              <span style="font-family: Roboto; font-size: 20px; color: #1E70EC">
                  {{props.column.label}}
              </span>
            </template>
          </vue-good-table>
        </div>
        <div class="column is-12">

        </div>
      </div>
      <b-modal :active.sync="isComponentModalActive" has-modal-card>
        <form action="" style="font-family: Roboto">
          <div class="modal-card">
            <header class="modal-card-head bg-primary">
                <span class="modal-card-title" style="color: white">
                  <span>{{userComment.fullName}}</span>
                  <!-- <span class="pull-right drag_pointer">
                    <v-icon color="white">apps</v-icon>
                  </span> -->
                </span>
            </header>
            <section class="modal-card-body">
              <!-- <div class="row"> -->
                <div class="columns">
                  <div class="column is-12">
                    <blockquote>
                      {{userComment.comment}}
                      <br/>
                      <small class="pull-right">{{userComment.organization}}</small>
                    </blockquote>
                  </div>
                </div>
            </section>
            <footer class="modal-card-foot pull-right">
                <button class="button is-danger pull-right" type="button" @click="isComponentModalActive = false">CLOSE</button>
                <span v-show="userType === 'superadmin'">
                  <button class="button is-primary" @click="sureDelete = !sureDelete">DELETE</button>
                  <button v-show="sureDelete" class="button is-warning" @click="removeComment(userComment.timestamp)">Click to confirm DELETE</button>
                </span>
                <span v-show="userType === 'admin'">
                  <button v-tooltip.bottom="'You dont have the permission to delete a comment'" disabled class="button is-primary">DELETE</button>
                  <!-- <small for="" v-show="sureDelete" class="blue--text">
                    You dont have the permission to delete a comment.
                  </small> -->
                </span>
            </footer>
          </div>
        </form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { db } from '@/assets/js-on/firebaseConfig';
import { setTimeout } from 'timers';
export default {
  name: 'feedback_adminview',
  components: {
  },
  data() {
    return {
      fullName: '',
      organization: '',
      comment: '',
      userComments: JSON.parse(this.$ls.get('user_comments')) || [],
      userType: this.$ls.get('user_type') || [],
      internetCheckURL: 'https://jsonplaceholder.typicode.com/todos/1',
      isComponentModalActive: false,
      sureDelete: false,
      userComment: {},
      deletedCommentsTimestamp: [],
      columns: [
        {
          field: 'fullName',
          label: 'Name',
          html: true,
        },
        {
          field: 'organization',
          label: 'Organization',
          html: true,
        },
        {
          field: 'comment',
          label: 'Comment',
          html: true,
        },
        {
          field: 'timestamp',
          label: 'Timestamp',
          hidden: true
        },
        {
          field: 'action',
          label: 'Action',
          html: true,
        },
      ],
      rows: []
    }
  },
  methods: {
    fetchComments() {
      var userComments = this.userComments.slice(0);
      this.$firestore.userComments.get()
      .then( querySnapShot => {
        var tempComments = [];
        querySnapShot.forEach( doc => {
          // console.log(doc.id, doc.data());
          let data = {
            'id': doc.id,
            'fullName': doc.data().fullName,
            'organization': doc.data().organization,
            'comment': doc.data().comment,
            'timestamp': doc.data().timestamp,
            'deleted': doc.data().deleted
          }
          tempComments.push(data);
        })
        // sync local storage with firestore...
        userComments = this.syncFirestoreToLocalstorage(tempComments, userComments);
        // update the localstorage with the latest comments from firestore.
        this.$ls.set('user_comments', JSON.stringify(userComments));
        // sort the comments in the order they were made...
        this.userComments = userComments.slice(0).sort( (a, b) => {return b.timestamp - a.timestamp} );

      }).catch( error => {
        console.log('cannot read from firestore', error);
      })
    },
    syncFirestoreToLocalstorage(tempComments, userComments) {
      var hasDocument = false;
      var commentsToSync = this.userComments.slice(0);
      for (var i = 0; i<tempComments.length; i++) {
        for (var j = 0; j<userComments.length; j++) {
          if (tempComments[i].timestamp === userComments[j].timestamp) {
            // document from firestore exists in local storage, skip
            hasDocument = true;
            break;
          }
        }
        // document from firestore doesn't exist and is not deleted, add
        if (!hasDocument && !tempComments[i].deleted ) {
          commentsToSync.push(tempComments[i]);
        }
        // reset hasDocument.
        hasDocument = false;
      }
      return commentsToSync.slice(0);
    },
    loadCommentTable() {

      this.rows = [];
      var tableRowProp = {};
      var userComments = this.userComments.slice(0);
      userComments.sort( (a, b) => {
        return b.timestamp - a.timestamp;
      });
      userComments.map( (elem, idx) => {
        tableRowProp.fullName = elem.fullName;
        tableRowProp.organization = elem.organization;
        tableRowProp.comment = elem.comment;
        tableRowProp.timestamp = elem.timestamp;
        this.rows.push(tableRowProp);
        tableRowProp = {};
      });
      tableRowProp = {};
    },
    rowStyleClassFn(row) {
      return row.originalIndex % 2 === 0 ? 'gray' : 'silver';
    },
    // load a single comment from the comments table
    loadComment(row, e) {
      // console.log(row, e);
      this.userComments.map( (elem, idx) => {
        if (elem.timestamp === row.timestamp) {
          this.userComment = elem;
        }
      })
      this.isComponentModalActive = !this.isComponentModalActive;
    },
    removeComment(timestamp) {
      // alert the user he's deleted an item
      alert('One comment deleted');
      //set timeout to remove the comment modal and reset sure delete variable
      setTimeout( () => {
        this.isComponentModalActive = !this.isComponentModalActive;
        this.sureDelete = !this.sureDelete;
      }, 1000);

      setTimeout( () => {
        // filter through the usercomments to get the deleted comment
        var userComments = this.userComments.slice(0).filter( (elem, idx, arr) => {
          return elem.timestamp !== timestamp
        });
        // reset usercomments
        this.userComments = userComments
        // update user_comments in local storage.
        this.$ls.set('user_comments', JSON.stringify(userComments));
        var deletedCommentsTimestamp = JSON.parse(this.$ls.get('deleted_comments'));
        if (!deletedCommentsTimestamp) {
          deletedCommentsTimestamp = [];
        }
        // we track deleted comments using their timestamps
        deletedCommentsTimestamp.push(timestamp);
        this.$ls.set('deleted_comments', JSON.stringify(deletedCommentsTimestamp));
        this.deletedCommentsTimestamp = deletedCommentsTimestamp;

      }, 1200)
    },
    checkDeletedComments( firebaseComments ){
      var deletedCommentsTimestamp = this.deletedCommentsTimestamp.slice(0);
      var commentsToDelete = []
      for (var i = 0; i<deletedCommentsTimestamp.length; i++) {
        for (var j = 0; j<firebaseComments.length; j++) {
          // console.log(deletedCommentsTimestamp[i].timestamp, firebaseComments[j].timestamp);
          if (deletedCommentsTimestamp[i] === firebaseComments[j].timestamp) {
            commentsToDelete.push(firebaseComments[i]);
            break;
          }
        }
      }
      return commentsToDelete;
    }
  },
  firestore() {
    return {
      userComments: db.collection('user_comments'),
    }
  },
  async created() {
    // load all comments from local storage...
    var userComments = JSON.parse(this.$ls.get('user_comments')) || [];
    this.userComments = userComments.slice(0).sort( (a, b) => {return b.timestamp - a.timestamp} )

    await this.axios.get(this.internetCheckURL)
    .then( result => {
      // get comments from firestore and save to local storage
      this.fetchComments(); // fetch synchronized comments...
    }).catch( error => {
      console.log('No internet available, cant fetch from firestore: ', error);
    })
  },
  mounted() {

    // this.loadCommentTable();
  },
  watch: {
    deletedCommentsTimestamp(val) {
      this.axios.get(this.internetCheckURL)
      .then( result => {
        this.$firestore.userComments.get()
        .then( querySnapShot => {
          var tempComments = [];
          querySnapShot.forEach( doc => {
            // console.log(doc.id, doc.data());
            let data = {
              'id': doc.id,
              'fullName': doc.data().fullName,
              'organization': doc.data().organization,
              'comment': doc.data().comment,
              'timestamp': doc.data().timestamp,
              'deleted': doc.data().deleted
            }
            tempComments.push(data);
          })
          // get the comments to delete on firestore
          var commentsToDelete =  this.checkDeletedComments(tempComments);
          console.log(commentsToDelete);
          commentsToDelete.map( (elem, idx) => {
            this.$firestore.userComments.doc(elem.id).update({
              // to delete is to set deleted field as true.
              // timestamp: (new Date()).getTime(),
              deleted: true
            })
            .then( result => {
              console.log("Document successfully deleted!");
            }).catch( error => {
              console.error("Error removing document: ", error);
            });
          })
        }).catch( error => {
          console.error('cannot read from firestore', error);
        })
      })
      .catch( error => {
        console.error('No internet connection, can\'t delete on firestore');
      })
    },
    userComments(){
      this.loadCommentTable();
    }
  }
}
</script>





// WEBPACK FOOTER //
// feedback.vue?dac514f2